import { useTranslation } from "react-i18next";

import { Form } from "react-bootstrap";

function RCHInvoiceForm({ rchInvoice, setRCHInvoice }) {
  const { t } = useTranslation();
  return (
    <div className="invoice-page__modal_form_invoice-container">
      <Form.Group>
        <Form.Label>Localisation: </Form.Label>
        <Form.Control
          label="text"
          as="textarea"
          rows={8}
          value={rchInvoice.localisation}
          onChange={(e) =>
            setRCHInvoice({
              ...rchInvoice,
              localisation: e.target.value,
            })
          }
        />
      </Form.Group>

      <Form.Group className="u-mb-small">
        <Form.Label>Activité(s):</Form.Label>
        <Form.Control
          as="textarea"
          rows={5}
          value={rchInvoice.activity}
          onChange={(e) =>
            setRCHInvoice({ ...rchInvoice, activity: e.target.value })
          }
        />
      </Form.Group>
    </div>
  );
}

export default RCHInvoiceForm;
